var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipIp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5487_728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 1H2.4C1.6268 1 1 1.6268 1 2.4V13.6C1 14.3732 1.6268 15 2.4 15H13.6C14.3732 15 15 14.3732 15 13.6V2.4C15 1.6268 14.3732 1 13.6 1Z",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 4V12H4V4H5.69141Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69801 12V4H9.85426C10.461 4 10.978 4.11589 11.405 4.34766C11.8321 4.57682 12.1576 4.89583 12.3816 5.30469C12.6082 5.71094 12.7214 6.17969 12.7214 6.71094C12.7214 7.24219 12.6069 7.71094 12.3777 8.11719C12.1485 8.52344 11.8165 8.83984 11.3816 9.06641C10.9493 9.29297 10.4259 9.40625 9.81129 9.40625H7.79957V8.05078H9.53785C9.86337 8.05078 10.1316 7.99479 10.3425 7.88281C10.5561 7.76823 10.7149 7.61068 10.8191 7.41016C10.9259 7.20703 10.9793 6.97396 10.9793 6.71094C10.9793 6.44531 10.9259 6.21354 10.8191 6.01562C10.7149 5.8151 10.5561 5.66016 10.3425 5.55078C10.129 5.4388 9.85816 5.38281 9.53004 5.38281H8.38941V12H6.69801Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5487_728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIp);
export default __webpack_public_path__ + "static/media/tooltipIP.e076228ebbcca23c1ac97710c692d3e5.svg";
export { ForwardRef as ReactComponent };